import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function BlogList({ darkMode }) {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchBlogs = async () => {
    try {
      const res = await fetch('/api/blogs');
      const data = await res.json();
      setBlogs(data);
      setTotalPages(Math.ceil(data.length / 5));
    } catch (err) {
      console.error('Failed to load blogs', err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const currentPagePosts = blogs
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice((page - 1) * 5, page * 5);

  const getPreview = (content) => {
    const lines = content.split('\n').slice(0, 5).join(' ');
    return lines + '...';
  };

  return (
    <div className={`max-w-4xl mx-auto p-6 pb-24 ${darkMode ? 'text-white bg-gray-800' : 'text-black bg-white'}`}> {/* pb-24 lagt til her */}
      <h2 className="text-2xl font-bold mb-4">Blog Posts</h2>

      {currentPagePosts.map((post) => (
        <div key={post._id} className="mb-6 border-b pb-4 relative">
          <h3 className="text-xl font-semibold">
            <Link to={`/blog/${post.slug}`} className="text-blue-600 hover:underline">
              {post.title}
            </Link>
          </h3>
          <p className="text-sm italic text-gray-400">
            by {post.author?.name || 'Unknown'} on {new Date(post.createdAt).toLocaleDateString()}
          </p>
          <div className="relative max-h-32 overflow-hidden">
            <p className="text-base mt-2 pr-4">
              {getPreview(post.content)}
            </p>
            <div className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-gray-800/90 to-transparent pointer-events-none"></div>
          </div>
        </div>
      ))}

      <div className="flex justify-between mt-6">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span>Page {page} of {totalPages}</span>
        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default BlogList;
